import { defineComponent as _defineComponent } from 'vue'
import ResponseForm from '@/components/Modals/Vacancy/ResponseForm.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponseModalContent',
  props: {
    close: { type: Function },
    info: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const __returned__ = { ResponseForm }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})